// @flow

import { configure } from "@api";

import createValueModule from "../create-value-module";

const { reducer, actions } = createValueModule("config", {
    loading: false,
    data: null,
    error: null,
});

let pending = null;

export const load = () => (dispatch: any, getState: any) => {
    if (pending) {
        return pending;
    }

    const { config } = getState();
    if (config.data) {
        return Promise.resolve(
            actions.set({ loading: false, data: config.data, error: null }),
        );
    }

    dispatch(actions.update({ loading: true }));

    // $FlowFixMe
    pending = fetch("/configuration/settings.json")
        .then(response => response.json())
        .then(data => {
            pending = null;
            configure(data.cognito);
            return dispatch(actions.set({ loading: false, data, error: null }));
        })
        .catch(error => {
            pending = null;
            return dispatch(actions.set({ loading: false, data: null, error }));
        });

    return pending;
};

export default reducer;
